/** Lista os acordos de determinada pasta */
import React, { Component } from "react";
import Base from "../../../../components/Base";
import AcordoView from "../../View/AcordoView";

import { withRouter } from "react-router-dom";
import { Button, Spin, Alert } from "antd";

import handleError from "../../../../services/apiErrorHandler";
import api from "../../../../services/api";
import * as Permission from "../../../../services/permissions";
import { isSuperUser } from "../../../../utils/is-superuser";

class AcordoPastaList extends Component {
  /** Componente responsável por listar os acordos de determinada pasta */
  state = {
    loading: true,
    pasta: {},
    acordos: null,
    error: null
  };

  /** Redirect */
  handleRedirect = path => {
    this.props.history.push(path);
  };

  async componentDidMount() {
    /** Carrega informações da pasta, e acordos */

    await this.handlePastaInfos();
    await this.handleAcordosInfos();

    this.setState({
      loading: false
    });
  }

  handleAcordosInfos = async () => {
    /** Obtém os acordos da pasta */
    const { id } = this.props.match.params;

    await api
      .get(`/acordo/acordos/?pasta=${id}`)
      .then(response => {
        this.setState({
          acordos: response.data
        });
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status == 403) {
            this.setState({
              error: "Sem permissão"
            });
          } else if (err.response.status != 404) {
            this.setState({
              error: handleError(err)
            });
          }
        }
      });
  };

  /**
   * Obtém informações da pasta
   */
  handlePastaInfos = async () => {
    const { id } = this.props.match.params;

    if (!this.state.loading) this.setState({ loading: true });

    await api
      .get(`/pasta/pastas/${id}/`)
      .then(response => {
        console.log("response", response);
        this.setState({
          pasta: response.data
        });
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status == 403) {
            this.setState({
              error: "Sem permissão"
            });
          } else if (err.response.status == 404) {
            this.setState({
              error: "Pasta não encontrada"
            });
          } else {
            this.setState({
              error: handleError(err)
            });
          }
        }
      });
  };

  render() {
    const isAdmin = isSuperUser();

    /** Loading infos */
    if (this.state.loading || this.state.error != null) {
      return (
        <Base
          title={this.state.pasta.pasta}
          subTitle="Acordos cadastrados"
          extra={[
            isAdmin ? (
              <Button
                key={1}
                type="primary"
                className="btn-green"
                onClick={() =>
                  this.handleRedirect(
                    `/acordo/create/${this.props.match.params.id}`
                  )
                }
              >
                Cadastrar acordo
              </Button>
            ) : null
          ]}
        >
          <div style={{ textAlign: "center" }}>
            {this.state.loading ? (
              <Spin />
            ) : (
              <Alert message={this.state.error} />
            )}
          </div>
        </Base>
      );
    }
    if (this.state.acordos == null || this.state.acordos.length == 0) {
      return (
        <Base
          title={this.state.pasta.pasta}
          subTitle="Acordos cadastrados"
          extra={[
            1 === 1 ? (
              <Button
                key={1}
                type="primary"
                className="btn-green"
                onClick={() =>
                  this.handleRedirect(
                    `/acordo/create/${this.props.match.params.id}`
                  )
                }
              >
                Cadastrar acordo
              </Button>
            ) : null
          ]}
        >
          <div style={{ textAlign: "center", padding: "10px" }}>
            <span>Esta pasta não possui nenhum acordo cadastrado.</span>
          </div>
        </Base>
      );
    }

    return (
      <Base
        title={this.state.pasta.pasta}
        subTitle="Acordos cadastrados"
        extra={[
          isAdmin ? (
            <Button
              key={1}
              type="primary"
              className="btn-green"
              onClick={() =>
                this.handleRedirect(
                  `/acordo/create/${this.props.match.params.id}`
                )
              }
            >
              Cadastrar acordo
            </Button>
          ) : null
        ]}
      >
        <div style={{ padding: "15px" }}>
          {this.state.acordos.map(acordo => (
            <AcordoView
              acordo={acordo}
              pasta={this.state.pasta}
              key={acordo.id}
            />
          ))}
        </div>
      </Base>
    );
  }
}
export default withRouter(AcordoPastaList);



// WEBPACK FOOTER //
// ./src/pages/Acordo/List/Pasta/index.js